import React, { useEffect, useState } from "react";
import axios from "axios";
import { BookOpen, Printer, ExternalLink } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";
import { AreaTile } from "../pages/PublicHome";
import CatalogView from "./CatalogView";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const catalogPdfUrl = (slug) => { const t = localStorage.getItem("kl_tenant"); return `${API}/public/catalogs/${slug}.pdf${t ? `?t=${t}` : ""}`; };
const qrSrc = (data, size = 220) => `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&margin=8&bgcolor=ffffff&color=18181c&data=${encodeURIComponent(data)}`;

// Versione stampabile: QR da inquadrare (apre il PDF) + link diretto
function PrintSheet({ d, onBack }) {
  const url = catalogPdfUrl(d.slug);
  return (
    <div className="rounded-3xl bg-white p-5 text-center space-y-3" data-testid="catalog-print-sheet">
      <div className="font-heading font-extrabold text-xl text-zinc-900">Versione stampabile</div>
      <p className="text-sm text-zinc-600">Inquadra il QR con un altro telefono o dal PC per aprire il catalogo PDF, oppure scaricalo da qui.</p>
      <img src={qrSrc(url)} alt="QR catalogo PDF" className="mx-auto h-52 w-52 rounded-xl ring-1 ring-zinc-200" data-testid="catalog-print-qr" />
      <a href={url} target="_blank" rel="noreferrer" className="inline-flex items-center justify-center gap-2 w-full rounded-2xl px-4 py-3 text-sm font-bold text-white" style={{ background: d.bg_color }} data-testid="catalog-print-pdf"><Printer className="h-4 w-4" /> Apri / scarica il PDF</a>
      <a href={url} target="_blank" rel="noreferrer" className="block text-[11px] text-zinc-500 break-all" data-testid="catalog-print-url"><ExternalLink className="h-3 w-3 inline mr-1" />{url}</a>
      <button type="button" onClick={onBack} className="text-sm font-semibold text-zinc-700 underline" data-testid="catalog-print-back">← Torna al catalogo</button>
    </div>
  );
}

// Home app cliente: tile "Sfoglia il catalogo" (una per raccolta con catalogo pubblicato) → catalogo in-app + versione stampabile con QR
export default function CatalogHome() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(null);
  const [print, setPrint] = useState(false);
  useEffect(() => {
    axios.get(`${API}/public/catalogs/active`).then((r) => {
      const list = r.data.items || [];
      setItems(list);
      if (list.length && new URLSearchParams(window.location.search).get("catalog")) { setOpen(list[0]); setPrint(false); }
    }).catch(() => {});
  }, []);
  if (!items.length) return null;
  const label = (d) => (items.length > 1 && d.collection ? `Catalogo · ${d.collection.name}` : "Sfoglia il catalogo");
  return (
    <>
      {items.map((d) => <AreaTile key={d.id} onClick={() => { setOpen(d); setPrint(false); }} icon={BookOpen} label={label(d)} colorKey="catalogo" testid={`public-tile-catalog-${d.collection?.id || "main"}`} />)}
      <Dialog open={!!open} onOpenChange={(o) => !o && setOpen(null)}>
        <DialogContent className="max-w-xl p-0 bg-transparent border-0 shadow-none max-h-[92vh] overflow-y-auto [&>button]:bg-black/50 [&>button]:text-white [&>button]:rounded-full [&>button]:p-1.5 [&>button]:opacity-100 [&>button]:right-3 [&>button]:top-3" data-testid="public-catalog-dialog" aria-describedby={undefined}>
          <DialogTitle className="sr-only">{open?.title || "Catalogo premi"}</DialogTitle>
          {open && (print ? <PrintSheet d={open} onBack={() => setPrint(false)} /> : <CatalogView d={open} embedded onPrint={() => setPrint(true)} testid="public-catalog-view" />)}
        </DialogContent>
      </Dialog>
    </>
  );
}
